import React from "react";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Calendar } from "../../../Assets/calendar.svg";
import { ReactComponent as LocationIcon } from "../../../Assets/location-dark.svg";
import { addItem } from "../../../Redux/slices/cartSlice";
import PropTypes from "prop-types";

import { capitalize, dateFormatter } from "../../../utils/helpers";
import { useDispatch } from "react-redux";
const Card = ({ data, index }) => {
  Card.propTypes = {
    data: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleEventDetails = () => {
    window.scrollTo(0, 0);
    navigate(`/event/${data.id}`, { state: { index } });
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();
    dispatch(addItem(data)); // Dispatch action to add item to cart
    navigate(`/cart/${data.id}`);
  };

  return (
    <div
      className="card"
      onClick={handleEventDetails}
      onKeyDown={handleEventDetails}
    >
      <div className="img_container">
        <img src={data?.coverImg} alt="event" />
        {data?.type && <div className="button">{capitalize(data?.type)}</div>}
      </div>
      <div className="card_content">
        <div
          className="title"
          onClick={() => navigate("/event/22")}
          onKeyDown={() => navigate("/event/22")}
        >
          {data?.title}
        </div>
        <div className="time">
          <Calendar />
          {dateFormatter(data?.startDate, data?.endDate, true)}
        </div>

        <div className="location">
          <LocationIcon />
          {data?.location?.type === "virtual"
            ? "Virtual Event"
            : data?.location?.city}
        </div>
        <div className="flex">
          <div className="price">
            {data?.startPrice
              ? `Starts from ₹${data?.startPrice}`
              : "Free Entry"}
          </div>
          <div
            className="button"
            onClick={handleAddToCart}
            onKeyDown={handleAddToCart}
          >
            Book Now
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
